// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e67c0f2b","239":"f984cd93","453":"5cfba62e","667":"9fb8a148"}[chunkId] + ".chunk.js";
};